import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild, ElementRef, input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { Property } from '../../models/property';
import { ensureSwiperElements } from '../swiper-register';

@Component({ standalone: false,
  selector: 'app-properties-carousel',
  templateUrl: './properties-carousel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./properties-carousel.component.scss'],
  
})
export class PropertiesCarouselComponent implements OnInit {
  @ViewChild('swiperRef') swiperRef: ElementRef | undefined;
  
  readonly properties = input<Property[]>([]);
  readonly id = input<number>(0);
  public routerPath:string='/properties';
  public slidesPerView:number=2;

  private breakpointSubscription?:Subscription;
  readonly breakpoint$;

  constructor(private breakpointObserver: BreakpointObserver, private router:Router) {
    ensureSwiperElements();
    this.breakpoint$ = this.breakpointObserver
      .observe([Breakpoints.XLarge, Breakpoints.Large, Breakpoints.Medium, Breakpoints.Small, Breakpoints.XSmall])
      .pipe(
        distinctUntilChanged()
    );
  }

  ngOnInit() {
    this.breakpointSubscription=this.breakpoint$.subscribe(() =>
      this.breakpointChanged()
    );
  }

  private get swiper() {
    return this.swiperRef?.nativeElement?.swiper;
  }

  swipePrev() {
    this.swiper?.slidePrev();
  }
  swipeNext() {
    this.swiper?.slideNext();
  }

  get nextButtonClass(){
    return '.swiper-button-next'+this.id();
  }
  get prevButtonClass(){
    return '.swiper-button-prev'+this.id();
  }

  private breakpointChanged() {
    if(this.breakpointObserver.isMatched(Breakpoints.XSmall)) {
      this.slidesPerView = 1;
    } 
    else if(this.breakpointObserver.isMatched(Breakpoints.Small)) {
      this.slidesPerView = 2;
    } 
    else if(this.breakpointObserver.isMatched(Breakpoints.Medium)) {
      this.slidesPerView = 3;
    } 
    else if(this.breakpointObserver.isMatched(Breakpoints.Large)) {
      this.slidesPerView = 4;
    }
    else if(this.breakpointObserver.isMatched(Breakpoints.XLarge)) {
      this.slidesPerView = 4;
    }
  }

  ngOnDestroy(){
    if(this.breakpointSubscription) this.breakpointSubscription.unsubscribe();
  }

  public onPropertyItemClicked(property:Property){
    this.router.navigate(['/properties/'+property.id]);
  }

}